import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { webSocketSubscriber } from '@/shared/api/web-socket-subscriber';

import { queryKeys } from '../api/subscription.queries';
import { subscriptionUpdatedNotificationSchema } from './subscription.schemas';

export function useSubscriptionUpdates() {
    const queryClient = useQueryClient();

    useEffect(() => {
        const handler = () => {
            void queryClient.invalidateQueries({ queryKey: queryKeys.me() });
        };

        webSocketSubscriber.subscribe(subscriptionUpdatedNotificationSchema, handler);
        return () =>
            webSocketSubscriber.unsubscribe(subscriptionUpdatedNotificationSchema, handler);
    }, []);
}
